import { Combobox, Transition } from "@headlessui/react";
import { SearchOutlined } from "@material-ui/icons";
import { observer } from "mobx-react-lite";
import React, { useState, useContext, useMemo, Fragment, useRef, useEffect } from "react";
import { useCallback } from "react";
import { Input, InputGroup, InputGroupAddon, InputGroupText } from "reactstrap";
import { labelHelper } from "../../helpers/labelHelper";
import Store from "../store/Store";
import SystemLabel from "./SystemLabel";

function PhoneNumberField(props) {
  const inputRef = useRef(null);
  const [countryCode, setCountryCode] = useState("se");
  const [prefix, setPrefix] = useState("46");
  const [countryCodeSelectOpen, setCountryCodeSelectOpen] = useState(false);
  const { settings, valid, invoice, ...inputProps } = props;

  const handleChange = useCallback(
    (e) => {
      if (settings?.showCountryCodeSelector) {
        if (!e.target.value?.startsWith(`+${prefix}`) && inputProps?.value) {
          const newValue = e.target.value?.split(" ");
          return inputProps.onChange(`+${prefix} ${newValue?.[1] ?? ""}`);
        }
        const newValue = e.target.value?.replace(`+${prefix}`, "").replace(/[^0-9_ +-]/g, "");
        inputProps.onChange(`+${prefix} ${newValue.trimStart()}`);
      } else if (invoice) {
        inputProps.onChange(e.target.value);
      } else {
        const newValue = e.target.value?.replace(/[^0-9_ +-]/g, "");
        inputProps.onChange(newValue);
      }
    },
    [prefix, inputProps, settings?.showCountryCodeSelector]
  );

  useEffect(() => {
    if (!inputProps?.value && settings?.showCountryCodeSelector) {
      inputProps.onChange(`+${prefix}`);
    }
  }, [inputProps?.value, inputProps?.onChange, prefix, settings?.showCountryCodeSelector]);

  const handleCodeChange = useCallback(
    ({ value, code }) => {
      inputProps.onChange(inputProps.value.replace(/\+[^\s]+/g, `+${value}`));
      setPrefix(value);
      setCountryCode(code);
      setCountryCodeSelectOpen(false);
    },
    [inputProps]
  );

  const inputStyle = inputRef.current ? window.getComputedStyle(inputRef.current) : {};

  if (settings?.showCountryCodeSelector) {
    return (
      <div style={{ position: "relative", width: inputStyle?.width, marginLeft: inputStyle?.marginLeft }}>
        <input ref={inputRef} hidden />
        <InputGroup style={{ display: "flex", flexWrap: "nowrap", width: "100%" }}>
          <InputGroupAddon addonType="append" className="input-addon" style={{ backgroundColor: "inherit" }}>
            <InputGroupText style={{ borderRadius: 0, borderTopLeftRadius: 5, borderBottomLeftRadius: 5, backgroundColor: "#fff", borderRight: 0, padding: "0 5px" }}>
              <button style={{ all: "unset", cursor: "pointer", display: "flex", alignItems: "center" }} onClick={() => setCountryCodeSelectOpen((prev) => !prev)}>
                <img src={`https://flagcdn.com/${countryCode?.toLowerCase()}.svg`} style={{ margin: "0 5px", maxWidth: 18, width: 18, height: "auto" }} />
              </button>
            </InputGroupText>
          </InputGroupAddon>
          <Input
            {...inputProps}
            onChange={handleChange}
            style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0, marginLeft: 0, width: "calc(100% + 16px + 36px)", border: valid === false ? "1px solid #d53443" : undefined }}
          />
        </InputGroup>
        <CountryCodeSelector open={countryCodeSelectOpen} onChange={handleCodeChange} countryCode={countryCode} />
      </div>
    );
  }
  return <Input innerRef={inputRef} style={{ border: valid === false ? "1px solid #d53443" : undefined }} {...inputProps} onChange={handleChange} />;
}

export default observer(PhoneNumberField);

const includes = (source, target) => source?.toLowerCase()?.includes(target.toLowerCase());

const CountryCodeSelector = ({ open, code, onChange }) => {
  const [query, setQuery] = useState("");
  const { countries } = useContext(Store);

  const countryCodeList = useMemo(() => countries?.map(({ alpha2Code, nameInt, phonePrefix }) => ({ code: alpha2Code, label: nameInt, value: phonePrefix })), [countries]);
  const filteredCountries = useMemo(() => countryCodeList.filter(({ label, value }) => includes(label, query) || includes(`+${value}`, query)), [countryCodeList, query]);

  return (
    open && (
      <div className="select-wrap selector intended" style={{ position: "absolute", zIndex: 40, transform: "translate(-1rem, 10px)", background: "#fff", width: "100%" }}>
        <Combobox value={null} onChange={(country) => onChange(country)}>
          <div className="autocomplete" style={{ height: "100%" }}>
            <div className="input-base" style={{ display: "flex", backgroundColor: "#fff", alignItems: "center", padding: "3px 10px", border: "1px solid gainsboro", width: "100%" }}>
              <SearchOutlined style={{ color: "#8b8888" }} />
              <Combobox.Input onChange={(event) => setQuery(event.target.value)} style={{ border: 0, background: "#fff", width: "100%" }} />
            </div>
            <Transition show as={Fragment} leave="transition ease-in duration-100" leaveFrom="opacity-100" leaveTo="opacity-0" afterLeave={() => setQuery("")}>
              <Combobox.Options style={{ listStyle: "none", background: "#fff", padding: "5px 0", overflowY: "auto", maxHeight: 300 }}>
                {filteredCountries?.length === 0 ? (
                  <div style={{ padding: 10 }}>
                    <SystemLabel name="NoResult" />
                  </div>
                ) : (
                  filteredCountries?.map(({ code, value, label }) => (
                    <Combobox.Option key={code} value={{ value, code }} as={Fragment} style={{ padding: "5px 10px", cursor: "pointer" }}>
                      {({ selected }) => (
                        <li className={selected ? "selected" : ""} style={{ display: "flex", cursor: "pointer" }}>
                          <img src={`https://flagcdn.com/${code?.toLowerCase()}.svg`} style={{ marginRight: 5, maxWidth: 18, width: 18, height: "auto" }} />
                          (+{value}) {label}
                        </li>
                      )}
                    </Combobox.Option>
                  ))
                )}
              </Combobox.Options>
            </Transition>
          </div>
        </Combobox>
      </div>
    )
  );
};
